'use strict';

/**
 * Payload builders for app-store-custom-app.js's this.save()
 * (AppTemplate.prototype$patchAttributes for an existing template,
 * AppTemplate.create for a new one). Pure functions so the payload shape can
 * be asserted in unit tests without instantiating the Angular controller.
 */
function buildAppTemplateUpdatePayload(appTemplate) {
    appTemplate = appTemplate || {};

    return {
        name: appTemplate.name,
        description: appTemplate.description,
    };
}

function buildAppTemplateCreatePayload(appTemplate, subAccountId) {
    const payload = Object.assign({}, appTemplate);
    if (subAccountId) {
        payload.subAccountId = subAccountId;
    }
    return payload;
}

var appStoreCustomAppSavePayload = {
    buildAppTemplateUpdatePayload: buildAppTemplateUpdatePayload,
    buildAppTemplateCreatePayload: buildAppTemplateCreatePayload,
};

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = appStoreCustomAppSavePayload;
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('appStoreCustomAppSavePayload', appStoreCustomAppSavePayload);
}
